var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Acesso de suporte de "+_vm._s(_vm.support.issuedBy)+" em "+_vm._s(_vm.support.customerName)+". "),(_vm.remaining > 0)?[_vm._v("Expira em "+_vm._s(_vm.countdown)+".")]:[_vm._v("Sessão expirada.")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }